import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import i18n from "i18next";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Large,
  Chat,
  FooterContainer,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
} from "./styles";



const Footer = ({ t }: { t: TFunction }) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };



  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between">
            <Col lg={3} md={3} sm={12} xs={12}>
              <Language>{t("Contact")}</Language>
              <Large to="/">{t("Tell us everything")}</Large>
              <Para>
                {t(`Do you have any question? Feel free to reach out.`)}
              </Para>
              <a href="mailto:comunicaciones@ejecomercial.co">
                <Chat>{t(`Let's Chat`)}</Chat>
              </a>
            </Col>
            <Col lg={3} md={3} sm={12} xs={12}>
              <Title>{t("Legal")}</Title>
              <Large to="/">{t("Términos y Condiciones")}</Large>
              <Large to="/">{t("Política de Privacidad")}</Large>
              <Large to="/">{t("Tratamiento de Datos")}</Large>
              <Large to="/">{t("SARLAFT")}</Large>
            </Col>
            <Col lg={3} md={3} sm={12} xs={12}>
              <Title>{t("Menú")}</Title>
              <Large to="/">{t("Nosotros")}</Large>
              <Large to="/">{t("Servicios")}</Large>
              <Large to="/">{t("Portales")}</Large>
              <Large to="/">{t("Contacto")}</Large>
            </Col>
            <Col lg={3} md={3} sm={12} xs={12}>
              <Label htmlFor="select-lang">{t("Language")}</Label>
              <LanguageSwitchContainer>
                <LanguageSwitch onClick={() => handleChange("en")}>
                  <SvgIcon
                    src="united-states.svg"
                    aria-label="homepage"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
                <LanguageSwitch onClick={() => handleChange("es")}>
                  <SvgIcon
                    src="spain.svg"
                    aria-label="homepage"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
              </LanguageSwitchContainer>
            </Col>
          </Row>
          <Row justify="space-between">
            {/* <Col lg={10} md={10} sm={12} xs={12}>
              <Empty />
              <Language>{t("Address")}</Language>
              <Para>Rancho Santa Margarita</Para>
              <Para>2131 Elk Street</Para>
              <Para>California</Para>
            </Col> */}
          </Row>
        </Container>
      </FooterSection>
      <Extra className="">
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem" }}
          >
            <NavLink to="/">
              <LogoContainer>
                <SvgIcon
                  src="log 2.svg"
                  aria-label="homepage"
                  width="100px"
                  height="66px"
                />
              </LogoContainer>
            </NavLink>
            <FooterContainer>

              <Col lg={12} md={12} sm={12} xs={12}>
                {t("EC&F © 2025 Todos los derechos reservados")}
              </Col>




            </FooterContainer>
            <FooterContainer>
            </FooterContainer>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
